import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class ResourcesTeamsActiveRoute extends Route {
  @service store;

  model() {
    return this.modelFor('settings.teams').teams.active;
  }
}

export default instrumentRoutePerformance(ResourcesTeamsActiveRoute);
